import { render } from "./FadeIn.vue?vue&type=template&id=5538bdc2&scoped=true"
import script from "./FadeIn.vue?vue&type=script&lang=js"
export * from "./FadeIn.vue?vue&type=script&lang=js"

import "./FadeIn.vue?vue&type=style&index=0&id=5538bdc2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5538bdc2"

export default script